module.exports = __webpack_public_path__ + "static/img/2.98c7feb0.svg";